import { FC, memo } from 'react'
import classNames from 'classnames'
import {
  CrewNavTab,
  CrewNavTabProps,
} from 'components/elements/crewNavTabs/components/crewNavTab'

export const CrewNavTabsDirection = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CrewNavTabDirection =
  (typeof CrewNavTabsDirection)[keyof typeof CrewNavTabsDirection]

type BaseProps = {
  tabItems: CrewNavTabProps[]
}

type HorizontalProps = BaseProps & {
  direction?: typeof CrewNavTabsDirection.Horizontal
  // 下部のグレーのボーダーを無効にするか
  // プロジェクト詳細などで、タブの範囲を超えて全体で下線を引きたい場合などにtrueにする
  disableBottomGrayBorder?: boolean
}

type VerticalProps = BaseProps & {
  direction: typeof CrewNavTabsDirection.Vertical
}

type CrewNavTabsProps = HorizontalProps | VerticalProps

// タブの方向に応じたクラス名を定義するための型
type TabClassNames = {
  // タブ全体のクラス名
  // flexの方向などを指定
  tabs: string
  // 選択されたタブのクラス名
  selectedTab: string
}

// 縦方向のタブ用クラス名
const VerticalClassNames: TabClassNames = {
  tabs: 'flex flex-col flex-none items-start gap-2.5 pr-5',
  selectedTab: 'border-l-2',
}

// 横方向のタブ用クラス名
const HorizontalClassNames: TabClassNames = {
  tabs: 'flex flex-row flex-none items-center',
  selectedTab: 'rounded-t-md border-b-2',
}

export const CrewNavTabs: FC<CrewNavTabsProps> = memo((props) => {
  const isHorizontal =
    props.direction === undefined ||
    props.direction === CrewNavTabsDirection.Horizontal

  const tabClassNames = isHorizontal ? HorizontalClassNames : VerticalClassNames

  // 横方向の場合、disableBottomGrayBorderがfalse（またはundefined）ならグレーのボーダーを適用
  const defaultBorderClass =
    isHorizontal && !props.disableBottomGrayBorder
      ? 'border-b crew-border-gray'
      : ''

  return (
    <div className={classNames(tabClassNames.tabs, 'h-10', defaultBorderClass)}>
      {/* tabItem分だけ表示する */}
      {props.tabItems.map((item) => (
        <CrewNavTab
          id={item.id}
          text={item.text}
          to={item.to}
          onClick={item.onClick}
          // Warning表示回避のkey指定
          key={item.text}
          icon={item.icon}
          badgeCount={item.badgeCount}
          badgeColor={item.badgeColor}
          selectedTabCustomClassName={tabClassNames.selectedTab}
        />
      ))}
    </div>
  )
})
